/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import ModalWithButtons from '../../../components/modal/ModalWithButtons';
import { Inputs } from '../../../../bphComponents/bundle';

const currentPastChoices = [
  {
    label: <FormattedMessage id="toggleCurrentPast.current.option.label" />,
    value: true,
    name: 'current',
  },
  {
    label: <FormattedMessage id="toggleCurrentPast.past.option.label" />,
    value: false,
    name: 'current',
  },
];

interface Props {
  healthEntry: any;
  onToggle(): void;
}
interface State {
  showModal: boolean;
  confirmDeleteMessage: string;
}
class HealthEntryCurrentPastToggle extends React.Component<Props, State> {

  constructor(props) {
    super(props);

    this.toggleCurrent = this.toggleCurrent.bind(this);

    this.state = {
      showModal: false,
      confirmDeleteMessage: '',
    };
  }

  toggleCurrent() {
    const { healthEntry } = this.props;
    if (!healthEntry.current.isCurrent()) {
      const hasEndDate = healthEntry.endDate.hasDate();
      const hasStoppingReason = healthEntry.stoppingReason && healthEntry.stoppingReason.hasStoppingReason();

      if (hasEndDate && hasStoppingReason) {
        this.setState({
          showModal: true,
          confirmDeleteMessage: 'healthEntryDates.discardEndDateStoppingReason.button.label',
        });
      } else if (hasEndDate) {
        this.setState({
          showModal: true,
          confirmDeleteMessage: 'healthEntryDates.discardEndDate.button.label',
        });
      } else if (hasStoppingReason) {
        this.setState({
          showModal: true,
          confirmDeleteMessage: 'healthEntryDates.discardStoppingReason.button.label',
        });
      } else {
        this.props.onToggle();

        this.setState({
          showModal: false,
          confirmDeleteMessage: '',
        });
      }
    } else {
      this.props.onToggle();
    }
  }

  render() {
    const isCurrent = this.props.healthEntry.current.isCurrent();
    return (
      <div>
        <Inputs.ToggleSwitch.ProfileThemedToggleSwitch
          value={isCurrent}
          choices={currentPastChoices}
          onChange={this.toggleCurrent}
          isOff={!isCurrent}
        />

        <ModalWithButtons
          isVisible={this.state.showModal}
          buttons={[
            {
              type: 'primary',
              action: 'destructive',
              text: <FormattedMessage id={this.state.confirmDeleteMessage} />,
              onClick: () => {
                this.props.onToggle();
                this.setState({
                  showModal: false,
                });
              },
            },
            {
              type: 'secondary',
              action: 'default',
              text: <FormattedMessage id="delete.deleteCancel.button.label" />,
              onClick: () => {
                this.setState({
                  showModal: false,
                });
              },
            },
          ]}
        />
      </div>
    );
  }
}

export default HealthEntryCurrentPastToggle;
